import { createServerFn } from '@tanstack/react-start';

export const stripParagraphBr = createServerFn({ method: 'POST' })
    .handler(async ({ data }) => {
        const { html } = data
        if (typeof html !== 'string') return html;
        return html.replace(/<p>\s*<br\s*\/?>\s*<\/p>/gi, '');
    });